<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;"><s-header-top></s-header-top></el-header>
			<el-header class="header"><s-header></s-header></el-header>
			<el-main>
				<div class="content">
					<el-row type="flex" justify="space-between">
						<el-col :span="12">
							<el-breadcrumb separator-class="el-icon-arrow-right">
								<span style="float: left;">当前位置：</span>
								<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
								<el-breadcrumb-item :to="{ path: '/expert' }">专家导师</el-breadcrumb-item>
							</el-breadcrumb>
						</el-col>
						<el-col :span="6">
							<el-input placeholder="输入关键字" v-model="title" @change="getExpertList"><el-button slot="append" icon="el-icon-search"></el-button></el-input>
						</el-col>
					</el-row>

					<el-row class="page">
						<el-col :span="4" class="type">
							<el-radio-group v-model="classify" @change="getExpertList">
								<el-radio label="" border>全部</el-radio>
								<el-radio border v-for="(item, index) in dictList" :key="index" :label="item.value">{{ item.label }}</el-radio>
							</el-radio-group>
						</el-col>
						<el-col :span="20" class="table">
							<el-row :gutter="40" class="lists">
								<div v-for="(item, index) in expertList" :key="index">
									<el-col class="list">
										<el-image
											style="width: 100%; height: 100%;border-radius: 7px;cursor: pointer;"
											:src="item.image ? imgPath(item.image) : require('../../static/p.jpg')"
											fit="fill"
											@click="goDetail(item)"
										></el-image>
										<div class="shade">
											<div class="name" @click="goDetail(item)">{{ item.name }}</div>
											<div class="type">{{ item.education }}</div>
											<div class="good">擅长领域：{{ item.workarea }}</div>
											<div class="consult" @click="call(item.telephone)">立即咨询</div>
										</div>
									</el-col>
								</div>
							</el-row>
							<pagination v-show="pageTotal>0" :total="pageTotal" :page.sync="currentPage" :limit.sync="pageSize" @pagination="getExpertList" />
						</el-col>
					</el-row>
				</div>
			</el-main>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeaderTop from '@/components/header_top';
import sHeader from '@/components/header';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import Pagination from '@/components/Pagination';
import { dictList, expertList } from '@/api';
export default {
	name: 'expert',
	components: {
		sHeaderTop,
		sHeader,
		sFooter,
		sCopyRight,
		Pagination
	},
	data() {
		return {
			title: '',
			classify: '',
			// 当前页数
			currentPage: 1,
			// 每页默认显示条数
			pageSize: 8,
			// 总条数
			pageTotal: 0,

			dictList: [],
			expertList: []
		};
	},
	mounted() {
		if (this.$route.query.keyWord) {
			this.title = this.$route.query.keyWord;
		}
		this.getDictList();
		this.getExpertList();
	},
	methods: {
		//获取字典列表
		getDictList() {
			let _this = this;
			dictList({
				type: 'msg_expert_classify'
			}).then(res => {
				_this.dictList = res.data;
			});
		},
		//获取专家导师列表
		getExpertList() {
			let _this = this;
			expertList({
				pageNo: _this.currentPage,
				pageSize: _this.pageSize,
				title: _this.title,
				classify: _this.classify
			}).then(res => {
				_this.expertList = res.data.list;
				_this.pageTotal = res.data.count;
			});
		},
		//专家导师详情
		goDetail(item) {
			let routeUrl = this.$router.resolve({
				path: '/expertDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: item.id
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		//图片地址
		imgPath(oldPath) {
			return this.$imgBaseUrl + oldPath;
		},
		//打电话
		call(phone) {
			this.$alert(phone ? phone : '暂未提供', '咨询热线', {
				confirmButtonText: '确定',
				callback: action => {}
			});
		}
	}
};
</script>

<style scoped>
.page {
	min-height: 618px; /*若没有tabs56  height524 若有height468 */
}
.type .el-radio-group {
	display: flex;
	flex-direction: column;
}
.type .el-radio {
	margin-left: 0 !important;
	margin-right: 0 !important;
	margin-bottom: 10px;
}
.table {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 20px;
	padding-right: 20px;
	margin-bottom: 20px;
}
.lists {
	width: 100%;
}
.list {
	height: 270px;
	width: 230px;
	margin-bottom: 20px;
	position: relative;
}
.shade {
	position: absolute;
	width: 190px; /* 230 - 20 -20 */
	bottom: 0;
	margin-right: 20px;
	border-radius: 0px 0px 7px 7px;
	background-color: rgba(0, 0, 0, 0.4);
	color: #ffffff;
	font-size: 14px;
	padding-top: 10px;
}
.consult {
	position: absolute;
	top: 10px;
	right: 0;
	width: 80px;
	height: 25px;
	line-height: 25px;
	border-radius: 15px 0px 0px 15px;
	background-color: #267ce4;
	text-align: center;
	border: 1px solid rgba(255, 255, 255, 0);
	cursor: pointer;
}
.name,
.type,
.good {
	line-height: 25px;
	padding-left: 10px;
	padding-right: 10px;
}
.name {
	font-weight: 600;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/expert.vue